var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Button } from "syf-component-library/ui/atoms";
import { Stack } from "syf-component-library/ui/spacing";
import { Body, H3 } from "syf-component-library/ui/typography";
import { generateUUID } from "syf-js-utilities";
import modalIds from "../../../../../const/modalIds";
import { useCreditHealthPutMutation } from "../../../../../const/syfApiQueries";
import { useVantageContext } from "../../../../../context/vantageContext";
import { useConfig } from "../../../../../hooks/useConfig";
import VantageTrans from "../../../../atoms/VantageTrans";
import { Modal, ModalContent } from "../subcomponents";
import unenrollButtonContent from "./unenrollButtonContent";
var UnenrollModalPopUp = function (_a) {
    var isOpen = _a.isOpen, vantageEnrolledAccounts = _a.vantageEnrolledAccounts, onClose = _a.onClose, openSuccessModal = _a.openSuccessModal;
    var config = useConfig();
    var t = useTranslation().t;
    var dispatch = useVantageContext().dispatch;
    var _b = useCreditHealthPutMutation({
        config: config,
    }), mutateAsync = _b.mutateAsync, isLoading = _b.isLoading;
    var handleUnenrollAllAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var promises, mutations, hasError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promises = vantageEnrolledAccounts.map(function (accountId) {
                        return mutateAsync({
                            "cipher.accountId": accountId,
                            accountIdType: "guid",
                            enrolled: false,
                        });
                    });
                    return [4 /*yield*/, Promise.allSettled(promises)];
                case 1:
                    mutations = _a.sent();
                    hasError = mutations.find(function (result) { return result.status === "rejected"; });
                    if (!hasError) {
                        openSuccessModal();
                    }
                    else {
                        onClose();
                        dispatch({ shouldShowErrorPage: true });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEscapeModal = function () {
        if (!isLoading) {
            onClose();
        }
    };
    return (_jsx(Modal, __assign({ id: "unenroll-popup", title: "Unenroll Modal", containerId: modalIds.UNENROLL_MODAL_ID, isOpen: isOpen, maxHeight: "600px", escapeModalHandler: handleEscapeModal, footerButtons: [
            _jsx(Button, __assign({ buttonType: "secondary", onClick: onClose, disabled: isLoading, type: "button", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "keep me enrolled" }, { children: t("unenrollModal.stayEnrolled") }), generateUUID()),
            _jsx(Button, __assign({ buttonType: "primary", disabled: isLoading, onClick: handleUnenrollAllAccounts, type: "button", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "unenroll me" }, { children: unenrollButtonContent(isLoading) }), generateUUID()),
        ] }, { children: _jsxs(ModalContent, { children: [_jsx(H3, __assign({ weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "unenrollModal.title" }) })), _jsx(Stack, { size: "base" }), _jsx(Body, { children: _jsx(VantageTrans, { i18nKey: "unenrollModal.body" }) }), _jsx(Stack, { size: "base" })] }) })));
};
export default UnenrollModalPopUp;
